import styled from 'styled-components'
import { colors } from '../../theme'

export const CardTopo = styled.div`
  display: flex;
  justify-content: space-between;
`
export const Wrapper = styled.div`
  padding: 20px;
`
export const Container = styled.div`
  box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.2);
  border-radius: 24px;
  width: 49%;
  background-color: ${colors.surface};
`
export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
`

export const WrapperTable = styled.div`
  align-items: end;
  display: flex;
  flex-direction: column;
`

export const ButtonCardStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${colors.grey100};
  padding: 2px;
  border-radius: 8px;
`
